export default "__VITE_ASSET__17116898__"